import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/Dashboard.css';

const SellerRecentSales = ({ sellerId }) => {
  const [recentSales, setRecentSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecentSales = async () => {
      if (!sellerId) return;
      
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        console.log('Obteniendo ventas recientes para el vendedor:', sellerId);
        
        // Usar el endpoint específico para obtener las ventas recientes del vendedor
        const response = await axios.get('/api/seller-sales/recent', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        console.log('Ventas recientes obtenidas:', response.data);
        setRecentSales(response.data);
        setError(null);
      } catch (error) {
        console.error('Error al obtener ventas recientes del vendedor:', error);
        setError('Error al cargar ventas recientes');
      } finally {
        setLoading(false);
      }
    };

    fetchRecentSales();
  }, [sellerId]);

  // Función para formatear la fecha sin manipulación de zona horaria
  const formatDate = (dateString) => {
    if (!dateString) return 'Fecha no disponible';
    
    try {
      // Formato esperado: "2025-05-09T00:00:00+00:00"
      console.log('Formateando fecha:', dateString);
      
      // Extraer solo la parte de la fecha (antes de la T)
      if (dateString.includes('T')) {
        const datePart = dateString.split('T')[0]; // "2025-05-09"
        
        // Convertir formato de fecha YYYY-MM-DD a DD/MM/YYYY
        const dateElements = datePart.split('-');
        if (dateElements.length === 3) {
          // Mostrar la fecha en formato DD/MM/YYYY
          return `${dateElements[2]}/${dateElements[1]}/${dateElements[0]}`;
        }
        
        return datePart;
      }
      
      // Si no es una fecha ISO, devolver la cadena original
      return dateString;
    } catch (e) {
      console.error('Error al formatear fecha:', e);
      return dateString;
    }
  };

  // Función para formatear el monto
  const formatAmount = (amount) => {
    if (amount === undefined || amount === null) return '$0.00';
    
    try {
      return '$' + parseFloat(amount).toFixed(2);
    } catch (e) {
      console.error('Error al formatear monto:', e);
      return '$0.00';
    }
  };

  if (loading) {
    return <div className="loading-message">Cargando ventas recientes...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="recent-sales-container">
      <h2>Ventas Recientes</h2>
      {recentSales && recentSales.length > 0 ? (
        <div className="table-container">
          <table className="sales-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Total</th>
                <th>Método de Pago</th>
              </tr>
            </thead>
            <tbody>
              {recentSales.map((sale, index) => {
                // Determinar qué campos usar para cada columna
                const dateValue = sale.date || sale.sale_fecha;
                const amountValue = sale.amount || sale.total;
                const paymentMethod = sale.sale_tipopago || 'Efectivo';
                
                return (
                  <tr key={sale.id || index}>
                    <td>{formatDate(dateValue)}</td>
                    <td>{formatAmount(amountValue)}</td>
                    <td>{paymentMethod}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No hay ventas recientes</p>
      )}
    </div>
  );
};

export default SellerRecentSales;
